export default "__VITE_ASSET__ZI0d$wHA__"